import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Modal, Button } from "antd";
import { FaEye } from "react-icons/fa";
import { fetchAnalyticsData } from "../../actions/AnalyticsActions";
import LogAnalytics from "./LogAnalytics";
import './Logs.css';

const Logs = () => {
  const dispatch = useDispatch();
  const analyticsData = useSelector((state) => state.analytics.visits);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  // useEffect(() => {
  //   dispatch(fetchAnalyticsData());
  // }, [dispatch]);

     useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

  const columns = [
    { title: "Time", dataIndex: "timestamp", key: "timestamp", render: (text) => new Date(text.seconds * 1000).toLocaleString() },
    { title: "Page", dataIndex: "page", key: "page" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => <Button icon={<FaEye />} type="text" onClick={() => showDetails(record)}>View Details</Button>,
    },
  ];

  const showDetails = (log) => {
    setSelectedLog(log);
    setIsModalVisible(true);
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: "100vh" }}>

      <LogAnalytics />

      <Table className="logs-card" title={()=><h3>All Logs</h3>} dataSource={analyticsData} columns={columns} rowKey="id" size="small" style={{marginTop:'20vh'}} />

      <Modal title="Log Details" visible={isModalVisible} onCancel={() => setIsModalVisible(false)} footer={null}>
        {selectedLog && (
          <div>
            <p><b>Page:</b> {selectedLog.page}</p>
            <p><b>Time:</b> {new Date(selectedLog.timestamp.seconds * 1000).toLocaleString()}</p>
            <p><b>OS:</b> {selectedLog.os}</p>
            <p><b>Device:</b> {selectedLog.device}</p>
            <p><b>Browser:</b> {selectedLog.browser}</p>
            <p><b>Location:</b> {selectedLog.location}</p>
          </div>
        )}
      </Modal>


    </div>
  );
};

export default Logs;
